// extracted by mini-css-extract-plugin
export default {"header":"pastdata_header__UcWdi","title":"pastdata_title__K4qjd","discription":"pastdata_discription__9tvP+"};